import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 17px;
`;
export const ButtonsContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 0.3s ease;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: end;
  padding-bottom: 20px;
  z-index: 30;
`;
export const HoverWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  opacity: 0.7;
  border-radius: 5;
`;
export const Button = styled.button`
  margin: 5px;
  padding: 8px 16px;
  background-color: #007bff; /* Example background color */
  color: #ffffff; /* Example text color */
  border: none;
  cursor: pointer;
`;
export const SearchWrapper = styled.div`
  margin-left: 20px;
`;
export const Title = styled.span`
  color: #2555ef;
  font-size: 18px;
  font-weight: 600;
  margin-left: 24px;
  margin-right: 24px;
`;
export const Content = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  padding-top: 20px;
  z-index: 100;
`;
export const TemplateName = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  min-height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 10;
  background-color: #fff;

  span {
    padding-left: 10px;
    font-size: 16px;
    color: "#404253";
    font-weight: 400;
  }
  border-top: 1px solid #e1e1e7;
`;

export const NoContentWrapper = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 100%;
`
export const CloseIcon = styled.div`
    width: 98%;
display:flex;
justify-content: flex-end;
align-items: center;
height: 50px;
`

export const MenuButton = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 30;
`